/* Méga-menu : recale le panneau dans la fenêtre quand il dépasse à droite. */
(function () {
  function clamp(details) {
    var p = details.querySelector('.pp-mega-panel');
    if (!p) return;
    p.style.transform = '';
    var r = p.getBoundingClientRect();
    var over = r.right - (document.documentElement.clientWidth - 16);
    if (over > 0) p.style.transform = 'translateX(-' + Math.ceil(over) + 'px)';
  }
  document.querySelectorAll('header details').forEach(function (d) {
    if (!d.querySelector('.pp-mega-panel')) return;
    new MutationObserver(function () { if (d.open) clamp(d); }).observe(d, { attributes: true, attributeFilter: ['open'] });
  });
})();
